import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface Municipio {
  codigo_ibge: string;
  nome: string;
  uf: string;
}

export const MUNICIPIOS_QUERY_KEY = ['municipios-autocomplete', 'full-v2'];

const fetchAllMunicipios = async (): Promise<Municipio[]> => {
  const allRows: Municipio[] = [];
  const pageSize = 1000;
  let offset = 0;
  let hasMore = true;

  while (hasMore) {
    const { data, error } = await supabase
      .from('municipios')
      .select('codigo_ibge, nome, uf')
      .order('nome')
      .range(offset, offset + pageSize - 1);

    if (error) throw error;

    const batch = (data || []) as Municipio[];
    allRows.push(...batch);
    offset += pageSize;
    hasMore = batch.length === pageSize;
  }

  return allRows;
};

export const useMunicipios = () =>
  useQuery({
    queryKey: MUNICIPIOS_QUERY_KEY,
    queryFn: fetchAllMunicipios,
    staleTime: 30 * 60 * 1000,
  });

